// =========================================
// Category Grid — Swiper slider.
//   Desktop (>=992): continuous marquee-style autoplay (delay 0 + linear).
//   Mobile  (<992):  one card at a time, auto-advancing.
// Re-inits across the breakpoint so each mode gets its own autoplay config.
// =========================================
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.block-category-grid__slider.swiper').forEach(function (el) {
        const mq = window.matchMedia('(min-width: 992px)');
        let swiper = null;

        const build = function () {
            if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }

            if (mq.matches) {
                // Desktop — continuous loop (no pause between cards).
                swiper = new Swiper(el, {
                    modules: [Autoplay],
                    slidesPerView: 'auto',
                    spaceBetween: 32,
                    loop: true,
                    speed: 6000,
                    allowTouchMove: false,
                    autoplay: { delay: 0, disableOnInteraction: false },
                });
            } else {
                // Mobile — peek cards (auto width), stepped advance (not continuous).
                swiper = new Swiper(el, {
                    modules: [Autoplay],
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    loop: true,
                    speed: 500,
                    allowTouchMove: false,
                    autoplay: { delay: 3500, disableOnInteraction: false },
                });
            }
        };

        build();
        mq.addEventListener('change', build);
    });
});
